import { postApi } from "./http.service"

export const getUserId=()=>{
   return localStorage.getItem("id");
}

export const getUserToken=()=>{
    return localStorage.getItem("token");
}

export const adminLogin=async(payload:any)=>{
    return postApi('auth/login/admin',payload);
}